import ManageRolesPage from "./ManageRolesPage";

export default ManageRolesPage;
